/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Post } from '../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { toast } from 'react-toastify';
import { Gtag, Linetag, FacebookPixel } from '../compornents/Analytics';

export const ItemMenu = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  let [customer, setCustomer] = useState([]);
  let [optionCategories, setOptionCategories] = useState([]);

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  useEffect(() => {
    let unmounted = false;
    (async () => {
      openLoadingModal();
      // 顧客情報取得
      let request_data = {};
      let response_data = await Post('post', '/customer/index.php', request_data);
      // console.log(response_data);
      if (response_data.result === 1) {
        if (!unmounted) setCustomer(response_data.customer);
      } else {
        // エラー
      }
      // オプション取得
      request_data = {};
      response_data = await Post('post', '/order/option_category.php', request_data);
      // console.log(response_data);
      if (response_data.result === 1) {
        if (!unmounted) setOptionCategories(response_data.option_categories);
      } else {
        // エラー
        // toast.error(response_data.error_message);
      }
      // 商品情報取得
      request_data = {};
      response_data = await Post('post', '/order/item.php', request_data);
      if (response_data.result === 1) {
        const items = response_data.items;
        if (!unmounted) setItems(items);
      } else {
        // エラー

      }
      closeLoadingModal();
    })();
    //クリーンアップ関数を返す
    return () => { unmounted = true; };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 商品選択
  async function selectItem(item) {
    // ふとん関連商品は詳細画面に遷移
    if(item.type === 'futon_bag' || item.type === 'futon') {
      navigate("/menu_detail", {
        state: {
          data: {
            item: item,
            customer: customer,
            lpspot: item.lpspot
          }
        }
      });
      return;
    }

    Gtag('select_item', { item_id: item.id });
    Linetag('ViewItemDetail');
    FacebookPixel('AddToCart');
    openLoadingModal();
    // 見積もり取得
    const request_data = {item_id: item.id,lpspot_id:item.lpspot.id}
    const response_data = await Post('post', '/order/quote.php', request_data);
    // console.log(response_data);
    if (response_data.result === 1) {
      const quote = response_data.quote;
      if(item.type ==='bag'){
        navigate("/confirm", { state: { data:{item: item, quote: quote,customer:customer,lpspot:item.lpspot,user_dropoff_type:'uber', from: "home"} } });
      }else if(optionCategories.length === 0){
        // オプションがない場合は直接確認画面へ
        navigate("/confirm", { state: { data:{item: item, quote: quote,customer:customer,lpspot:item.lpspot,option_categories:optionCategories,user_dropoff_type:'uber', from: "home"} } });
      }else{
        navigate("/option_category", { state: { data:{item: item, quote: quote,customer:customer,lpspot:item.lpspot,option_categories:optionCategories,user_dropoff_type:'uber'} } });
      }
    } else {
      // エラー
      toast.error(response_data.error_message);
    }
    closeLoadingModal();
  };
  const ItemMenu = items.map((item) =>{
    const columnClass = Number(items.length) >= 2  ? "col-6" : "offset-1 col-10";
    return (<div className={`${columnClass} mb-2 div_btn`} onClick={() => selectItem(item)} key={item.id}>
      <img src={item.img} className="ItemImage" alt="Item" />
      <div className="mt-2 ml-2">
        <div className="h6">
          {item.name}
        </div>
        <div className="text-gray-dark">
          <small>{item.intro}</small>
        </div>
        <div className="h6 text-right">
          ¥{Number(item.kin2).toLocaleString()}
        </div>
      </div>
  </div>);
  }
  );
  return (
    <div>
      <div>
        <div className="">
          <div className="h5 mt-4 mb-2 text-center">
            <div className="home_title">メニューを<br />お選びください</div>
          </div>
          <div className="mb-4">
            <div className="row">
              {ItemMenu}
            </div>
          </div>

          {items.length > 1 && (
            <div className="text-right">
              <small>※別途Uber配達手数料が加算されます</small>
            </div>
          )}
          <div className="text-right">
            <small>※金額は全て税込です</small>
          </div>
        </div>
      </div>
      <LoadingModal>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          <button onClick={closeLoadingModal} className="hide">閉じる</button>
          <div >
            <TailSpin stroke="#000" />
          </div>
          <div className="">
            <div className="">
              処理中です
            </div>
          </div>
        </div>
      </LoadingModal>
    </div>
  )
}
